import { alpha, Button, styled, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import {
  EmergencyIcon,
  FaceNeutralIcon,
  MessageAlertSquareIcon,
  PhoneHangUpIcon,
} from 'assets/svg';
import { useAppSelector } from 'features/app/hooks';
import {
  PreviousCallSelector,
  VrsCallCommentsButton,
} from 'features/call/vrs-call-comments/components';
import { ReportType } from 'features/call/vrs-call-comments/enums';
import { useVrsCallCommentsHandlers } from 'features/call/vrs-call-comments/hooks';
import { selectIsAnyPreviousCallMode } from 'features/call/vrs-call-comments/store';
import theme from 'features/theme/theme';
import { usePreviousCalls } from 'features/call/previous-calls/hooks';

export const VrsCallComments = () => {
  const isAnyPreviousCallMode = useAppSelector(selectIsAnyPreviousCallMode);
  const {
    previousCalls: displayCalls,
    selectedCallId,
    selectCall,
    isEmpty: isPreviousCallsEmpty,
  } = usePreviousCalls();

  const { handleReportTypeClick, handleCancel } =
    useVrsCallCommentsHandlers(displayCalls);

  const { t } = useTranslation('translation', { keyPrefix: 'callComments' });
  const { t: ct } = useTranslation();

  return (
    <Container>
      <MessageAlertSquareIcon />
      <Typography
        variant='h1'
        color={theme.palette.common.white}
        align='center'
        whiteSpace='pre-line'
        mt={12}
      >
        {t('title')}
      </Typography>

      {isAnyPreviousCallMode && (
        <PreviousCallSelector
          displayCalls={displayCalls}
          selectedCallId={selectedCallId}
          selectCall={selectCall}
          isPreviousCallsEmpty={isPreviousCallsEmpty}
        />
      )}

      <ButtonsWrapper>
        <VrsCallCommentsButton
          icon={<PhoneHangUpIcon title='phoneHangUpIcon' />}
          title={t('billable')}
          onClick={() => handleReportTypeClick(ReportType.NON_BILLABLE)}
        />
        <VrsCallCommentsButton
          icon={<EmergencyStyledIcon title='emergencyIcon' />}
          title={t('abuse')}
          onClick={() => handleReportTypeClick(ReportType.ABUSE)}
        />
        <VrsCallCommentsButton
          icon={<FaceNeutralIcon title='faceIcon' />}
          title={t('bug')}
          onClick={() => handleReportTypeClick(ReportType.BUG_REPORT)}
        />
      </ButtonsWrapper>
      <CancelReportBtn
        fullWidth
        size='large'
        color='secondary'
        title={ct('cancel')}
        onClick={handleCancel}
      >
        {ct('cancel')}
      </CancelReportBtn>
    </Container>
  );
};

const Container = styled('div')`
  width: 432px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: ${alpha(theme.palette.grey[900], 0.5)};
  border-radius: 8px;
  padding: ${theme.spacing(31, 23, 23)};
`;

const ButtonsWrapper = styled('div')`
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding-top: ${theme.spacing(16)};
`;

const EmergencyStyledIcon = styled(EmergencyIcon)`
  path {
    stroke: ${theme.palette.grey[100]};
  }
`;

const CancelReportBtn = styled(Button)`
  margin-top: ${theme.spacing(16)};
`;
